var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c(
        "el-header",
        { attrs: { height: "42px" } },
        [
          _c(
            "el-button-group",
            { staticClass: "ik-list-menu" },
            [
              _vm.pageData.mode === "edit" || _vm.pageData.mode === "details"
                ? _c(
                    "el-button",
                    {
                      staticClass: "ik-list-menu-btn",
                      attrs: { size: "medium" },
                      on: { click: _vm.infoCreateBtn },
                    },
                    [_vm._v("新增 ")]
                  )
                : _vm._e(),
              _vm.pageData.mode === "details"
                ? _c(
                    "el-button",
                    {
                      staticClass: "ik-list-menu-btn",
                      attrs: { size: "medium" },
                      on: { click: _vm.infoUpdateBtn },
                    },
                    [_vm._v("修改 ")]
                  )
                : _vm._e(),
              _vm.pageData.mode === "edit" || _vm.pageData.mode === "details"
                ? _c(
                    "el-button",
                    {
                      staticClass: "ik-list-menu-btn",
                      attrs: { size: "medium" },
                      on: { click: _vm.infoCopyBtn },
                    },
                    [_vm._v("复制 ")]
                  )
                : _vm._e(),
              _vm.pageData.mode === "edit"
                ? _c(
                    "el-button",
                    {
                      staticClass: "ik-list-menu-btn",
                      attrs: { size: "medium" },
                      on: { click: _vm.infoDetailsBtn },
                    },
                    [_vm._v("详情 ")]
                  )
                : _vm._e(),
              _vm.pageData.mode === "add" || _vm.pageData.mode === "edit"
                ? _c(
                    "el-button",
                    {
                      staticClass: "ik-list-menu-btn",
                      attrs: { size: "medium" },
                      on: { click: _vm.infoSaveBtn },
                    },
                    [_vm._v(" 保存 ")]
                  )
                : _vm._e(),
              _vm._t("endButton"),
              _c(
                "el-button",
                {
                  staticClass: "ik-list-menu-btn",
                  attrs: { size: "medium" },
                  on: { click: _vm.infoCancelBtn },
                },
                [_vm._v("取消 ")]
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "el-main",
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "ik-info-head",
              attrs: {
                id: "ik-info-head",
                model: _vm.pageData.formData.head,
                inline: true,
                "label-width": "120px",
                disabled: _vm.pageData.mode === "details",
              },
            },
            _vm._l(_vm.pageData.formItems, function (row) {
              return _c(
                "el-row",
                { key: row.rowIndex },
                _vm._l(row.items, function (col) {
                  return _c(
                    "el-col",
                    {
                      key: col.id,
                      staticClass: "mb-5",
                      attrs: { span: col.span },
                    },
                    [
                      col.type === "select"
                        ? _c(
                            "form-select-item",
                            _vm._b(
                              {
                                ref: `input_${col.code}`,
                                refInFor: true,
                                attrs: {
                                  code: col.code,
                                  name: col.name,
                                  "key-field": "key",
                                  "value-field": "value",
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.pageData.formData.head[col.code],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pageData.formData.head,
                                      col.code,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pageData.formData.head[col.code]",
                                },
                              },
                              "form-select-item",
                              col.config,
                              false
                            )
                          )
                        : col.type === "group"
                        ? _c(
                            "form-group-select-item",
                            _vm._b(
                              {
                                attrs: {
                                  code: col.code,
                                  name: col.name,
                                  url: col.config.url,
                                  "data-down": _vm.loading,
                                },
                                model: {
                                  value: _vm.pageData.formData.head[col.code],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pageData.formData.head,
                                      col.code,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pageData.formData.head[col.code]",
                                },
                              },
                              "form-group-select-item",
                              col.config,
                              false
                            )
                          )
                        : col.type === "date"
                        ? _c(
                            "form-date-item",
                            _vm._b(
                              {
                                attrs: {
                                  code: col.code,
                                  name: col.name,
                                  url: col.config.url,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.pageData.formData.head[col.code],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pageData.formData.head,
                                      col.code,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pageData.formData.head[col.code]",
                                },
                              },
                              "form-date-item",
                              col.config,
                              false
                            )
                          )
                        : col.type === "time"
                        ? _c(
                            "form-time-item",
                            _vm._b(
                              {
                                attrs: {
                                  code: col.code,
                                  name: col.name,
                                  url: col.config.url,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.pageData.formData.head[col.code],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pageData.formData.head,
                                      col.code,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pageData.formData.head[col.code]",
                                },
                              },
                              "form-time-item",
                              col.config,
                              false
                            )
                          )
                        : col.type === "datetime"
                        ? _c(
                            "form-datetime-item",
                            _vm._b(
                              {
                                attrs: {
                                  code: col.code,
                                  name: col.name,
                                  url: col.config.url,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.pageData.formData.head[col.code],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pageData.formData.head,
                                      col.code,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pageData.formData.head[col.code]",
                                },
                              },
                              "form-datetime-item",
                              col.config,
                              false
                            )
                          )
                        : col.type === "number"
                        ? _c(
                            "form-number-item",
                            _vm._b(
                              {
                                attrs: { code: col.code, name: col.name },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.pageData.formData.head[col.code],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pageData.formData.head,
                                      col.code,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pageData.formData.head[col.code]",
                                },
                              },
                              "form-number-item",
                              col.config,
                              false
                            )
                          )
                        : col.type === "oss"
                        ? _c(
                            "form-image-item",
                            _vm._b(
                              {
                                ref: `input_${col.code}`,
                                refInFor: true,
                                attrs: { code: col.code, name: col.name },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.pageData.formData.head[col.code],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pageData.formData.head,
                                      col.code,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pageData.formData.head[col.code]",
                                },
                              },
                              "form-image-item",
                              col.config,
                              false
                            )
                          )
                        : col.type === "video"
                        ? _c(
                            "form-video-item",
                            _vm._b(
                              {
                                ref: `input_${col.code}`,
                                refInFor: true,
                                attrs: { code: col.code, name: col.name },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.pageData.formData.head[col.code],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pageData.formData.head,
                                      col.code,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pageData.formData.head[col.code]",
                                },
                              },
                              "form-video-item",
                              col.config,
                              false
                            )
                          )
                        : col.type === "popup"
                        ? _c(
                            "form-popup-item",
                            _vm._g(
                              _vm._b(
                                {
                                  ref: `input_${col.code}`,
                                  refInFor: true,
                                  attrs: { code: col.code, name: col.name },
                                  model: {
                                    value: _vm.pageData.formData.head[col.code],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.pageData.formData.head,
                                        col.code,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "pageData.formData.head[col.code]",
                                  },
                                },
                                "form-popup-item",
                                col.config,
                                false
                              ),
                              col.handleEvent
                            )
                          )
                        : _c(
                            "form-text-item",
                            _vm._b(
                              {
                                ref: `input_${col.code}`,
                                refInFor: true,
                                attrs: { code: col.code, name: col.name },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.pageData.formData.head[col.code],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pageData.formData.head,
                                      col.code,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pageData.formData.head[col.code]",
                                },
                              },
                              "form-text-item",
                              col.config,
                              false
                            )
                          ),
                    ],
                    1
                  )
                }),
                1
              )
            }),
            1
          ),
        ],
        1
      ),
      _c("soltForm", {
        scopedSlots: _vm._u(
          [
            {
              key: "endForm",
              fn: function () {
                return [_vm._t("endForm")]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }